import { Steps } from 'antd';
import React from 'react';
import type { DataAttributes } from '@/components/utils/TypeUtils';
import type { StepProgressItem } from '@/components/utils/Interfaces';
import { getPrefixedDataAttributes } from '@/components/utils/DomUtils';
import Icon from '@/components/Icon/Icon';
import './StepProgress.scss';

interface StepProgressProps {
  /** The data-* attribute is used to store custom data private to the page or application. */
  dataAttributes?: DataAttributes;
  /** Array of step object to be used in each step */
  stepArray: StepProgressItem[];
  /** Index of the current step */
  currentStep: number;
  /** Specify an optional className to be applied to the container node */
  className?: string;
  /** Keep original icons for finished steps instead of replacing with done icon */
  keepOriginalIcons?: boolean;
}

/** StepProgress is a visual indicator that shows the users progress through a series of steps. It's often used to keep the user focussed toward completing a task. */
const StepProgress: React.FC<StepProgressProps> = ({
  dataAttributes,
  stepArray,
  currentStep,
  className,
  keepOriginalIcons = false,
}) => {
  const doneIcon = <Icon source="/src/assets/svg/done.svg" className="icon--step-done" />;

  /** Updating to done icon once the steps is finished */
  // prettier-ignore
  const updatedStepArray = keepOriginalIcons
    ? stepArray
    : stepArray.map((step, index) => {
      if (index < currentStep) {
        return {
          ...step,
          icon: doneIcon,
        };
      }

      return step;
    });

  return (
    <Steps
      direction="vertical"
      className={className}
      current={currentStep}
      items={updatedStepArray}
      {...getPrefixedDataAttributes(dataAttributes, 'StepProgress')}
    />
  );
};

StepProgress.displayName = 'StepProgress';

export default StepProgress;
